import React, { Component } from 'react';
import { connect } from 'react-redux';
import { goBack, replace } from 'connected-react-router';

import { clearSearch } from '../../redux/actions/result.action';
import { loadContentForPage, backAndStop, setData, loadText, isPlaying } from '../../redux/actions/text.action';
import Rodal from 'rodal';
import './TitleBar.scss';
import { detect } from 'detect-browser';
import 'rodal/lib/rodal.css';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import text from '../../assets/text/text.json';
//icons
import helpIcon from '../../assets/help.png';
import closeIcon from '../../assets/close.svg';
import backIcon from '../../assets/back.png';
import restartIcon from '../../assets/home.svg';
import speakerIcon from '../../assets/speaker.svg';
import ReactPlayer from 'react-player';
import Text2Voice from '../Text2Voice/Text2Voice';

const browser = detect();

class TitleBar extends Component<{ noNavigation?: boolean, goBack: any, goHome: any, clearSearch: any, back?: any, page?: any, setCurrentpage: any, setData: any }, { visibleModal: boolean, questions: any, faqVideo: string, play: boolean, message: string }> {
  constructor(props: any) {
    super(props);
    this.state = {
      visibleModal: false,
      questions: [],
      faqVideo: "",
      play: false,
      message: ''
    };
  }


  show() {
    this.setState({ visibleModal: true });
    this.props.setData(null);
  }

  play(item: any, rnd: any) {
    this.setState({ message: item['Question'] + rnd.__html, play: true })
  }

  hide() {
    this.setState({ visibleModal: false });

    this.props.setData(null);
  }

  componentDidMount() {
    this.setState({ questions: text.home.Help.Accordion });
    this.setState({ faqVideo: text.home.Help['Video'] });
  }

  private renderAccordion() {
    return this.state.questions.map((item: any, i: number) =>
      <AccordionItem key={i}>
        <AccordionItemHeading>
          <AccordionItemButton>
            <div className="help-header">
              {item['Question']}
              <img src={speakerIcon} className="help-speaker" onClick={() => {
                this.setState({ message: item['Question'] + " " + item['Answer'].__html, play: true })
              }} />
            </div>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <div dangerouslySetInnerHTML={item['Answer']} />
        </AccordionItemPanel>
      </AccordionItem>)
  }

  private renderTitleBarNoNavigation() {
    return (
      <div className="titlebar">
        <div className="titlebar-item">

        </div>
        <div className="titlebar-item" onClick={this.show.bind(this)}>
          <img src={helpIcon} className="titlebar-img" alt="help-icon" />
          <div className="titlebar-text">Hilfe</div>
        </div>
        <div className="titlebar-item"></div>
        {this.state.visibleModal && <Rodal animation="slideUp" customStyles={{ marginTop: 0, height: '100%', borderRadius: 0, backgroundImage: 'linear-gradient(270deg, #f3b633 0%, #f8d68c 100%)' }} visible={this.state.visibleModal} onClose={this.hide.bind(this)}>
          <div className="rodal-titlebar">
            <span>Hilfe</span>
            <div className="rodal-custom-close" onClick={this.hide.bind(this)}>
              <img src={closeIcon} alt="close" />
              schließen
            </div>
          </div>
          <div className="rodal-content">
            {this.state.faqVideo !== "" && this.state.visibleModal && <ReactPlayer url={this.state.faqVideo} width="100%" />}
            <Accordion allowZeroExpanded="true">
              {this.renderAccordion()}
            </Accordion>
          </div>
        </Rodal>}
      </div>
    );
  }

  private renderTitleBar() {
    return (
      <div className="titlebar">
        <div className="titlebar-item" onClick={() => {
          if (this.props.back) {
            this.props.back();
          } else {
            this.props.goBack();
          }

          this.props.setData(null);
        }}>
          <img src={backIcon} className="back-icon" alt="back-icon" />
        </div>
        <div className="titlebar-item" onClick={this.show.bind(this)}>
          <img src={helpIcon} className="titlebar-img" alt="help-icon" />
          <div className="titlebar-text">Hilfe</div>
        </div>
        <div className="titlebar-item" onClick={() => {
          this.props.clearSearch();
          this.props.goHome();
        }}>
          <img src={restartIcon} className="titlebar-img" alt="restart-icon" />
        </div>
        {this.state.visibleModal && <Rodal width="738" animation="slideUp" customStyles={{ marginTop: 0, height: '100%', borderRadius: 0, backgroundImage: 'linear-gradient(270deg, #f3b633 0%, #f8d68c 100%)' }} visible={this.state.visibleModal} onClose={this.hide.bind(this)}>
          <div className="rodal-titlebar">
            <span>Hilfe</span>
            <div className="rodal-custom-close" onClick={this.hide.bind(this)}>
              <img src={closeIcon} alt="close" />
              schließen
            </div>
          </div>
          <div className="rodal-content">
            {this.state.faqVideo !== "" && this.state.visibleModal && <ReactPlayer url={this.state.faqVideo} width="100%" />}
            <Accordion allowZeroExpanded="true">
              {this.renderAccordion()}
            </Accordion>
          </div>
        </Rodal>}
      </div>
    );
  }

  /**
   * Main render method
   */
  render() {
    return (
      <div style={{width: '100%'}}>
        {this.state.play && <Text2Voice textArray={[this.state.message]} playing={this.state.play} callback={() => {
          this.setState({ play: false, message: '' });

        }} />}
        {this.props.noNavigation && this.renderTitleBarNoNavigation()}
        {!this.props.noNavigation && this.renderTitleBar()}
      </div>
    )
  }
}

const mapStateToProps = (state: any) => {
  return {

  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    goBack() {
      dispatch(backAndStop());
    },
    goHome() {
      dispatch(replace('/home'));
    },
    clearSearch() {
      dispatch(clearSearch());
    },
    setCurrentpage() {
      dispatch(loadContentForPage("home"));
    },
    setData(data: any) {
      dispatch(setData(data))
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TitleBar);